/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Calendar_ListInputs */

const es_tools_calendar_list = /** @type {(inputs: Tools_Calendar_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando calendarios de Google...`)
};

const en_tools_calendar_list = /** @type {(inputs: Tools_Calendar_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Google calendars...`)
};

/**
* | output |
* | --- |
* | "Listing Google calendars..." |
*
* @param {Tools_Calendar_ListInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_calendar_list = /** @type {((inputs?: Tools_Calendar_ListInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Calendar_ListInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_calendar_list(inputs)
	return en_tools_calendar_list(inputs)
});
export { tools_calendar_list as "tools.calendar.list" }